import React, { useEffect } from 'react';
import { MagnifyingGlassIcon, CaretIcon } from '@rsos/assets/icons';
import { AnimateRotate } from '@rsos/utils/springAnimations';
import { SearchButton, IconWrapper } from './ConnectedUniversalSearch.styles';

export const SearchDropdownMenu = ({
  onClick,
  selected,
  searchTerm,
  isDropdownClicked,
  isDropdownTriggeredByKey,
  onDropdownClicked,
  onDropdownTriggeredByKey,
  setSearchTerm,
  clearOutError,
}) => {
  useEffect(() => {
    if (searchTerm === '/' && !isDropdownClicked && !isDropdownTriggeredByKey) {
      onDropdownClicked(true);
      onDropdownTriggeredByKey(true);
      onClick();
    } else if (searchTerm === '//' && isDropdownTriggeredByKey) {
      onDropdownClicked(false);
      onDropdownTriggeredByKey(false);
      setSearchTerm('/// ');
    } else if (!searchTerm && isDropdownClicked && isDropdownTriggeredByKey) {
      onDropdownClicked(false);
      onDropdownTriggeredByKey(false);
      onClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  useEffect(() => {
    if (isDropdownClicked !== selected) {
      onDropdownClicked(selected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  const handleSearchOptionsToggle = () => {
    onDropdownClicked(prev => !prev);
    clearOutError();
    onClick();
  };
  return (
    <SearchButton
      btnType="tertiary"
      size="med"
      onClick={handleSearchOptionsToggle}
      type="button"
      noMargin
    >
      <IconWrapper>
        <MagnifyingGlassIcon width="15px" height="15px" />
      </IconWrapper>
      <AnimateRotate
        config={{ duration: 0 }}
        rotate={!isDropdownClicked}
        from={0}
        to={180}
      >
        <CaretIcon width={10} height={10} color="secondaryLink" />
      </AnimateRotate>
    </SearchButton>
  );
};
